import React from 'react';
import ReactDOM from 'react-dom';
import {Route, BrowserRouter, Switch} from 'react-router-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import {routes} from "./util/config";
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import Login from "./containers/login/login";
import {ProtectedPages} from "./shared/protectedPages/protectedPages";
import UserControl from "./containers/userControl/userControl";
import Users from './containers/users/users';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-select/dist/react-select.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import Groups from "./containers/cst_group/groups";
import NewGroup from "./containers/cst_group/newGroup";
import Claimed from "./containers/cst_group/claimed";
import ExperiencesHistory from "./containers/experiences/experiencesHistory";
import Experience from './containers/experiences/experience';
import Live from './containers/live/live'

ReactDOM.render(
    <BrowserRouter>
        <App>
            <Switch>
                <Route  path={routes.login} component={Login}/>
                <Route  path={routes.live} component={Live}/>
                <ProtectedPages path={routes.userControl} component={UserControl}/>
                <ProtectedPages path={routes.users} component={Users}/>
                <ProtectedPages path={routes.groups} component={Groups}/>
                <ProtectedPages path={routes.newGroup} component={NewGroup}/>
                <ProtectedPages path={routes.item} component={Claimed}/>
                <ProtectedPages path={routes.experiencesHistory} component={ExperiencesHistory}/>
                <ProtectedPages path={routes.experience} component={Experience}/>
                <ProtectedPages  path="/" component={ExperiencesHistory}/>
            </Switch>
        </App>
    </BrowserRouter>
    , document.getElementById('root'));
unregister();
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js